import { render } from "./LinkOpcoesDialog.vue?vue&type=template&id=91167d6c"
import script from "./LinkOpcoesDialog.vue?vue&type=script&lang=js"
export * from "./LinkOpcoesDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__